import { createElementVNode as _createElementVNode, withModifiers as _withModifiers, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelSelect as _vModelSelect, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/logo-white.png'


const _withScopeId = n => (_pushScopeId("data-v-27bbd581"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("figure", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Logo d'EHOP en bleu"
  })
], -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn name w15" }, "Nom"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn mail w15" }, "Email"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn enabled w5" }, "Actif"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn substart w10" }, "Début"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn subend w10" }, "Fin"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn lastactivity w10" }, "Connexion"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn code w10" }, "Mdp"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn head w10" }, "Nombre Max"),
    /*#__PURE__*/_createElementVNode("th", { class: "tabcolumn btns w15" })
  ])
], -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["id", "onMouseenter"]
const _hoisted_5 = ["onClick"]
const _hoisted_6 = ["value"]
const _hoisted_7 = ["onClick"]
const _hoisted_8 = ["value"]
const _hoisted_9 = { class: "tabcolumn enabled w5" }
const _hoisted_10 = ["onChange"]
const _hoisted_11 = ["selected"]
const _hoisted_12 = ["selected"]
const _hoisted_13 = ["onClick"]
const _hoisted_14 = ["value"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = ["value"]
const _hoisted_17 = { class: "tabcolumn lastactivity w10" }
const _hoisted_18 = ["value"]
const _hoisted_19 = ["value"]
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["value"]
const _hoisted_23 = { class: "tabcolumn btns w15" }
const _hoisted_24 = ["onClick"]
const _hoisted_25 = ["onClick"]
const _hoisted_26 = { key: 1 }
const _hoisted_27 = {
  id: "AddUserRow",
  class: "hidden"
}
const _hoisted_28 = { class: "tabcolumn name w15" }
const _hoisted_29 = { class: "tabcolumn mail w15" }
const _hoisted_30 = { class: "tabcolumn enabled w5" }
const _hoisted_31 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", {
  value: "true",
  selected: "selected"
}, "Oui", -1))
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("option", { value: "false" }, "Non", -1))
const _hoisted_33 = [
  _hoisted_31,
  _hoisted_32
]
const _hoisted_34 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tabcolumn substart w10" }, "- ", -1))
const _hoisted_35 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tabcolumn subend w10" }, "- ", -1))
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", null, "-", -1))
const _hoisted_37 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("td", { class: "tabcolumn code w10" }, "- ", -1))
const _hoisted_38 = { class: "tabcolumn head w10" }
const _hoisted_39 = { class: "tabcolumn btns w15" }
const _hoisted_40 = ["id", "onMouseenter"]
const _hoisted_41 = ["onClick"]
const _hoisted_42 = ["value"]
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["value"]
const _hoisted_45 = { class: "tabcolumn enabled w5" }
const _hoisted_46 = ["onChange"]
const _hoisted_47 = ["selected"]
const _hoisted_48 = ["selected"]
const _hoisted_49 = ["onClick"]
const _hoisted_50 = ["value"]
const _hoisted_51 = ["onClick"]
const _hoisted_52 = ["value"]
const _hoisted_53 = { class: "tabcolumn lastactivity w10" }
const _hoisted_54 = ["value"]
const _hoisted_55 = ["value"]
const _hoisted_56 = ["onClick"]
const _hoisted_57 = ["onClick"]
const _hoisted_58 = ["value"]
const _hoisted_59 = { class: "tabcolumn btns w15" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = ["onClick"]
const _hoisted_62 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("header", null, [
      _hoisted_1,
      _createElementVNode("div", null, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          onChange: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_ctx.ResearchUser($event)), ["prevent"])),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.researchFieldValue) = $event)),
          placeholder: "Rechercher"
        }, null, 544), [
          [_vModelText, _ctx.researchFieldValue]
        ]),
        _createElementVNode("input", {
          id: "AddUserBtn",
          type: "button",
          value: "Ajouter",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.ShowAddUserRow($event)))
        })
      ])
    ]),
    (_ctx.apiError.length > 0)
      ? (_openBlock(), _createElementBlock("p", {
          key: 0,
          class: "error",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.apiError.pop()))
        }, _toDisplayString(_ctx.apiError[_ctx.apiError.length-1]), 1))
      : _createCommentVNode("", true),
    _createElementVNode("table", {
      onMouseleave: _cache[35] || (_cache[35] = ($event: any) => (_ctx.OnMouseExitTable($event)))
    }, [
      _hoisted_2,
      (_ctx.resultUsers.length > 0)
        ? (_openBlock(), _createElementBlock("tbody", _hoisted_3, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.resultUsers, (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user.uniqid,
                id: user.uniqid,
                onMouseenter: ($event: any) => (_ctx.OnMouseOverTableRow($event, user.uniqid))
              }, [
                _createElementVNode("td", {
                  class: "tabcolumn name w15",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "disabled",
                    name: "Names",
                    onKeyup: _cache[4] || (_cache[4] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.details.firstname + ' ' + user.details.lastname
                  }, null, 40, _hoisted_6)
                ], 8, _hoisted_5),
                _createElementVNode("td", {
                  class: "tabcolumn mail w15",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "mail",
                    class: "disabled",
                    name: "Email",
                    onKeyup: _cache[6] || (_cache[6] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[7] || (_cache[7] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.details.email
                  }, null, 40, _hoisted_8)
                ], 8, _hoisted_7),
                _createElementVNode("td", _hoisted_9, [
                  _createElementVNode("select", {
                    name: "Enabled",
                    onChange: ($event: any) => (_ctx.OnChangeTableCellSelect($event, user.uniqid))
                  }, [
                    _createElementVNode("option", {
                      value: "true",
                      selected: user.enabled
                    }, "Oui", 8, _hoisted_11),
                    _createElementVNode("option", {
                      value: "false",
                      selected: !user.enabled
                    }, "Non", 8, _hoisted_12)
                  ], 40, _hoisted_10)
                ]),
                _createElementVNode("td", {
                  class: "tabcolumn substart w10",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "date",
                    class: "disabled",
                    name: "Substart",
                    onKeyup: _cache[8] || (_cache[8] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[9] || (_cache[9] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.sub.dates.from != '1970-01-01' ? user.sub.dates.from : ''
                  }, null, 40, _hoisted_14)
                ], 8, _hoisted_13),
                _createElementVNode("td", {
                  class: "tabcolumn subend w10",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "date",
                    class: "disabled",
                    name: "Subend",
                    onKeyup: _cache[10] || (_cache[10] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[11] || (_cache[11] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.sub.dates.to != '1970-01-01' ? user.sub.dates.to : ''
                  }, null, 40, _hoisted_16)
                ], 8, _hoisted_15),
                _createElementVNode("td", _hoisted_17, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "disabled",
                    value: user.headsets.last_activity != '1970-01-01' ? user.headsets.last_activity : '-',
                    disabled: "",
                    required: ""
                  }, null, 8, _hoisted_18)
                ]),
                _createElementVNode("td", {
                  class: "tabcolumn code w10",
                  onMouseenter: _cache[12] || (_cache[12] = ($event: any) => (_ctx.OnMouseOverCellPassword($event))),
                  onMouseleave: _cache[13] || (_cache[13] = ($event: any) => (_ctx.OnMouseOutCellPassword($event)))
                }, [
                  _createElementVNode("input", {
                    type: "password",
                    class: "disabled",
                    value: user.details.password
                  }, null, 8, _hoisted_19),
                  _createElementVNode("button", {
                    type: "button",
                    name: "Password",
                    onClick: ($event: any) => (_ctx.GeneratePassword($event, user.uniqid))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: [ 'fas', 'rotate-left' ] })
                  ], 8, _hoisted_20)
                ], 32),
                _createElementVNode("td", {
                  class: "tabcolumn head w10",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "number",
                    class: "disabled",
                    name: "MaxHeadsets",
                    onKeyup: _cache[14] || (_cache[14] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[15] || (_cache[15] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.headsets.max_headsets
                  }, null, 40, _hoisted_22)
                ], 8, _hoisted_21),
                _createElementVNode("td", _hoisted_23, [
                  _createElementVNode("input", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.WatchDevices($event, user.uniqid)),
                    value: "Modifier"
                  }, null, 8, _hoisted_24),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.DeleteUser($event, user.uniqid))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: [ 'fas', 'trash' ] })
                  ], 8, _hoisted_25)
                ])
              ], 40, _hoisted_4))
            }), 128))
          ]))
        : (_openBlock(), _createElementBlock("tbody", _hoisted_26, [
            _createElementVNode("tr", _hoisted_27, [
              _createElementVNode("td", _hoisted_28, [
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.addedUser.details.firstname) = $event)),
                  placeholder: "Prénom"
                }, null, 512), [
                  [_vModelText, _ctx.addedUser.details.firstname]
                ]),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.addedUser.details.lastname) = $event)),
                  placeholder: "Nom"
                }, null, 512), [
                  [_vModelText, _ctx.addedUser.details.lastname]
                ])
              ]),
              _createElementVNode("td", _hoisted_29, [
                _withDirectives(_createElementVNode("input", {
                  type: "mail",
                  "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.addedUser.details.email) = $event)),
                  placeholder: "Email"
                }, null, 512), [
                  [_vModelText, _ctx.addedUser.details.email]
                ])
              ]),
              _createElementVNode("td", _hoisted_30, [
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.addedUser.enabled) = $event)),
                  disabled: ""
                }, _hoisted_33, 512), [
                  [_vModelSelect, _ctx.addedUser.enabled]
                ])
              ]),
              _hoisted_34,
              _hoisted_35,
              _hoisted_36,
              _hoisted_37,
              _createElementVNode("td", _hoisted_38, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.addedUser.headsets.max_headsets) = $event))
                }, null, 512), [
                  [_vModelText, _ctx.addedUser.headsets.max_headsets]
                ])
              ]),
              _createElementVNode("td", _hoisted_39, [
                _createElementVNode("input", {
                  type: "button",
                  value: "Ajouter",
                  onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.SendNewUser($event)))
                }),
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.CancelNewUser($event)))
                }, [
                  _createVNode(_component_font_awesome_icon, { icon: [ 'fas', 'trash' ] })
                ])
              ])
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.users, (user) => {
              return (_openBlock(), _createElementBlock("tr", {
                key: user.uniqid,
                id: user.uniqid,
                onMouseenter: ($event: any) => (_ctx.OnMouseOverTableRow($event, user.uniqid))
              }, [
                _createElementVNode("td", {
                  class: "tabcolumn name w15",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "disabled",
                    name: "Names",
                    onKeyup: _cache[23] || (_cache[23] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[24] || (_cache[24] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.details.firstname + ' ' + user.details.lastname
                  }, null, 40, _hoisted_42)
                ], 8, _hoisted_41),
                _createElementVNode("td", {
                  class: "tabcolumn mail w15",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "mail",
                    class: "disabled",
                    name: "Email",
                    onKeyup: _cache[25] || (_cache[25] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[26] || (_cache[26] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.details.email
                  }, null, 40, _hoisted_44)
                ], 8, _hoisted_43),
                _createElementVNode("td", _hoisted_45, [
                  _createElementVNode("select", {
                    name: "Enabled",
                    onChange: ($event: any) => (_ctx.OnChangeTableCellSelect($event, user.uniqid))
                  }, [
                    _createElementVNode("option", {
                      value: "true",
                      selected: user.enabled
                    }, "Oui", 8, _hoisted_47),
                    _createElementVNode("option", {
                      value: "false",
                      selected: !user.enabled
                    }, "Non", 8, _hoisted_48)
                  ], 40, _hoisted_46)
                ]),
                _createElementVNode("td", {
                  class: "tabcolumn substart w10",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "date",
                    class: "disabled",
                    name: "Substart",
                    onKeyup: _cache[27] || (_cache[27] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[28] || (_cache[28] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.sub.dates.from != '1970-01-01' ? user.sub.dates.from : ''
                  }, null, 40, _hoisted_50)
                ], 8, _hoisted_49),
                _createElementVNode("td", {
                  class: "tabcolumn subend w10",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "date",
                    class: "disabled",
                    name: "Subend",
                    onKeyup: _cache[29] || (_cache[29] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[30] || (_cache[30] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.sub.dates.to != '1970-01-01' ? user.sub.dates.to : ''
                  }, null, 40, _hoisted_52)
                ], 8, _hoisted_51),
                _createElementVNode("td", _hoisted_53, [
                  _createElementVNode("input", {
                    type: "text",
                    class: "disabled",
                    value: user.headsets.last_activity != '1970-01-01' ? user.headsets.last_activity : '-',
                    disabled: "",
                    required: ""
                  }, null, 8, _hoisted_54)
                ]),
                _createElementVNode("td", {
                  class: "tabcolumn code w10",
                  onMouseenter: _cache[31] || (_cache[31] = ($event: any) => (_ctx.OnMouseOverCellPassword($event))),
                  onMouseleave: _cache[32] || (_cache[32] = ($event: any) => (_ctx.OnMouseOutCellPassword($event)))
                }, [
                  _createElementVNode("input", {
                    type: "password",
                    class: "disabled",
                    value: user.details.password
                  }, null, 8, _hoisted_55),
                  _createElementVNode("button", {
                    type: "button",
                    name: "Password",
                    onClick: ($event: any) => (_ctx.GeneratePassword($event, user.uniqid))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: [ 'fas', 'rotate-left' ] })
                  ], 8, _hoisted_56)
                ], 32),
                _createElementVNode("td", {
                  class: "tabcolumn head w10",
                  onClick: ($event: any) => (_ctx.OnMouseClickTableCell($event, user.uniqid))
                }, [
                  _createElementVNode("input", {
                    type: "number",
                    class: "disabled",
                    name: "MaxHeadsets",
                    onKeyup: _cache[33] || (_cache[33] = ($event: any) => (_ctx.OnValidTableCellInput($event))),
                    onBlur: _cache[34] || (_cache[34] = ($event: any) => (_ctx.OnBlurTableCellInput($event))),
                    value: user.headsets.max_headsets
                  }, null, 40, _hoisted_58)
                ], 8, _hoisted_57),
                _createElementVNode("td", _hoisted_59, [
                  _createElementVNode("input", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.WatchDevices($event, user.uniqid)),
                    value: "Casques"
                  }, null, 8, _hoisted_60),
                  _createElementVNode("input", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.WatchLogs($event, user.uniqid)),
                    value: "Logs"
                  }, null, 8, _hoisted_61),
                  _createElementVNode("button", {
                    type: "button",
                    onClick: ($event: any) => (_ctx.DeleteUser($event, user.uniqid))
                  }, [
                    _createVNode(_component_font_awesome_icon, { icon: [ 'fas', 'trash' ] })
                  ], 8, _hoisted_62)
                ])
              ], 40, _hoisted_40))
            }), 128))
          ]))
    ], 32)
  ]))
}